import { Button, ButtonIcon, Icon, Typography } from '@saviynt/design-system';
import { useNavigate } from '@tanstack/react-router';
import { FormattedMessage, useIntl } from 'react-intl';

import { TOKENS } from '../../../../shared/constants';

import './PolicyPageHeader.css';

/**
 * Header for Agent Policy page.
 */
export default function PolicyPageHeader() {
  const navigate = useNavigate();
  const intl = useIntl();

  return (
    <div className='PolicyPageHeader'>
      <div className='PolicyPageHeader-row'>
        <ButtonIcon
          size='large'
          kind='ghost'
          icon={<Icon kind='ChevronLeft' size='medium' />}
          ariaLabel={intl.formatMessage({
            id: 'XsANoV',
            defaultMessage: 'Go back to previous page',
            description: 'Aria label for back button',
          })}
          onClick={() => navigate({ to: '..', from: '/policies' })}
        />
        <Typography kind='h1' color={TOKENS.CF_NEU_BLD} isNoWrap>
          <FormattedMessage
            id='S33B/6'
            defaultMessage='Rules for AI Agents'
            description='Policies page header title'
          />
        </Typography>
        <Button
          kind='filled'
          size='large'
          leftIcon={<Icon kind='Add' />}
          className='PolicyPageHeader-action'
          onClick={() => navigate({ to: '/policies/new' })}>
          <FormattedMessage
            id='wQlluM'
            defaultMessage='New Rule'
            description='Label for new policy button'
          />
        </Button>
      </div>
    </div>
  );
}
